const DEFAULT_BRAND_NAME = 'Chatwoot';
const DEFAULT_CUSTOM_BRAND_NAME = 'Ibritha';

const currentInstallationName = () =>
  window.globalConfig?.INSTALLATION_NAME ||
  window.globalConfig?.BRAND_NAME ||
  DEFAULT_CUSTOM_BRAND_NAME;

const brandString = value => {
  const installationName = currentInstallationName();

  if (!installationName || installationName === DEFAULT_BRAND_NAME) {
    return value;
  }

  return value
    .replace(/Chatwoot/g, installationName)
    .replace(/Woot server/g, `${installationName} server`);
};

export const brandI18nMessages = messages => {
  if (typeof messages === 'string') {
    return brandString(messages);
  }

  if (Array.isArray(messages)) {
    return messages.map(item => brandI18nMessages(item));
  }

  if (messages && typeof messages === 'object') {
    return Object.fromEntries(
      Object.entries(messages).map(([key, value]) => [
        key,
        brandI18nMessages(value),
      ])
    );
  }

  return messages;
};
